export default __webpack_public_path__ + "static/media/6.4183a4df.png";